import { render } from "./DetailSearchFormPage.vue?vue&type=template&id=61969be2&ts=true"
import script from "./DetailSearchFormPage.vue?vue&type=script&lang=ts"
export * from "./DetailSearchFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__